import StepsWidget from './steps-widget';

export default StepsWidget;
